import { Serializer } from "../resource/serializer.interface";
import { PreferenceOption } from "./preference-option.model";

export class PreferenceOptionSerializer implements Serializer {
    fromJson(json: any): PreferenceOption {
        const preferenceOption = new PreferenceOption();
        preferenceOption.id = json.id;
        preferenceOption.code = json.code;
        preferenceOption.value = json.value;
        preferenceOption.tenantId = json.tenant_id;
        preferenceOption.order = json.order;
        return preferenceOption;
    }

    toJson(preferenceOption: PreferenceOption): any {
        return {
            id: preferenceOption.id,
            code: preferenceOption.code,
            value: preferenceOption.value,
            tenant_id: preferenceOption.tenantId,
            order: preferenceOption.order
        };
    }
}
